import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'

const ProductSliderItem = ({
  isSelected,
  isDisabled,
  value,
  onClick,
  label,
  className,
}) => {
  const containerRef = useRef(null)
  const slideClasses = classNames('product-slider-item btn-inline', className, {
    active: isSelected,
    disabled: isDisabled,
  })

  useEffect(() => {
    if (isSelected) {
      containerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }
  }, [isSelected])

  return (
    <button
      type="button"
      data-value={value}
      className={slideClasses}
      onClick={onClick}
      ref={containerRef}
    >
      {label}
    </button>
  )
}

export default ProductSliderItem
